export type MediaItem = {
    id: string
    type: string
    source: string
    prompt: string
    cdn_url: string
    duration: number
    width?: number
    height?: number
    usage?: string
    reference_images_ids?: string[]
    aspect_ratio?: string
    title?: string
    style?: string
    mode?: string
    vocal_gender?: string
    voice_id?: string
    voice_id_2?: string | null
    tone?: string
    image_id?: string
    audio_id?: string | null
    video_id?: string | null
    modelKey?: string
    modelLabel?: string
}

export type ExampleProject = {
    id: string
    title: string
    concept: string
    videoSrc: string
    thumbnailSrc: string
    credits: number
    creating_time: string
    type: string
    width: number
    height: number
    duration: number
    story: string
    screen_write: string
    metadata: Record<string, any>
    characters: Record<string, any>
    images: Record<string, MediaItem>
    musics: Record<string, MediaItem>
    sound_effects: Record<string, MediaItem>
    speechs: Record<string, MediaItem>
    videos: Record<string, MediaItem>
    timeline_editor: {
        project_id: string
        timeline_duration: number
        background_color: string
        tracks: Array<{
            index: number
            label: string
            locked: boolean
            visible: boolean
        }>
        elements: Array<{
            id: string
            media_id: string
            media_type: string
            src: string
            content: string
            color: string
            track: number
            start_time: number
            duration: number
            local_path: string | null
            volume: number
            trim_start: number | null
            trim_end: number | null
            original_duration: number | null
        }>
    }
}


export const examples: ExampleProject[] = [
    {
        "id": "1",
        "title": "Coca-Cola Ad",
        "concept": "A 17-second YouTube ad for Coca-Cola, blending classic vintage aesthetics with modern visuals to bring the iconic refreshment to life, featuring the classic bottle and the satisfying sounds of pouring and fizz.",
        "videoSrc": "https://cdn.aibrush.co/docs/examples/example-1.mp4",
        "thumbnailSrc": "https://cdn.aibrush.co/docs/examples/example-1.png",
        "credits": 926.6,
        "creating_time": "30 minutes to create",
        "type": "Commercial",
        "width": 1920,
        "height": 1080,
        "duration": 17,
        "story": "A story about refreshment and shared moments with Coca-Cola.",
        "screen_write": "Screenplay to be developed.",
        "metadata": {
            "brand": "Coca-Cola",
            "theme": "Vintage to Modern, Refreshment",
            "ad_type": "Commercial",
            "platform": "YouTube"
        },
        "characters": {},
        "images": {
            "01K4DPHV2CBMPWG8QT80Z0SQ0P": {
                "id": "01K4DPHV2CBMPWG8QT80Z0SQ0P",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "A perfectly composed shot of a clear glass filled with Coca-Cola and ice cubes, showcasing abundant effervescent fizz rising to the top. Condensation is prominent on the glass, indicating coldness. The lighting is bright and inviting, emphasizing the refreshing bubbles. A clean, simple background that doesn't distract from the drink.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/images/01K4DPHV2CBMPWG8QT80Z0SQ0P_0_01K4DPK8CG39CZMVP7EATNGAGZ.png",
                "duration": 0,
                "width": 1920,
                "height": 1080,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": "16:9",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4DPHTZQ13MBJ2XCQEEK8V25": {
                "id": "01K4DPHTZQ13MBJ2XCQEEK8V25",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "A dynamic still image capturing Coca-Cola being poured from a classic bottle into a clear glass filled with ice cubes. The liquid is mid-pour, creating a splash, with visible bubbles and foam. The lighting is crisp, highlighting the rich amber color of the soda and the texture of the ice. A dark, neutral background to make the action pop.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/images/01K4DPHTZQ13MBJ2XCQEEK8V25_0_01K4DPK7RH50J3TQH6NEDHDSQV.png",
                "duration": 0,
                "width": 1920,
                "height": 1080,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": "16:9",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4DPHTS9H8ZS33HJ3JQZ72RX": {
                "id": "01K4DPHTS9H8ZS33HJ3JQZ72RX",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "A vintage Coca-Cola magazine advertisement from the 1950s, showing the classic contoured bottle, with a faded, aged paper texture. The colors are slightly desaturated, capturing an authentic retro feel. The background is a warm, wooden table.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/images/01K4DPHTS9H8ZS33HJ3JQZ72RX_0_01K4DPK8XXB3ZQTKVD1447V3RH.png",
                "duration": 0,
                "width": 1920,
                "height": 1080,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": "16:9",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4DPHTW6YX58D8NG5VCFE4H6": {
                "id": "01K4DPHTW6YX58D8NG5VCFE4H6",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "A close-up, high-definition shot of a classic glass Coca-Cola bottle, covered in condensation, glistening under bright studio lighting. The bottle is perfectly centered, with a subtle depth of field blurring a minimalist background. Emphasize the iconic shape and the cold, refreshing feel.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/images/01K4DPHTW6YX58D8NG5VCFE4H6_0_01K4DPK9A03FTVDJGW6TXW9M11.png",
                "duration": 0,
                "width": 1920,
                "height": 1080,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": "16:9",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4DPHV74B2MH5K1YFDT9V4TF": {
                "id": "01K4DPHV74B2MH5K1YFDT9V4TF",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "A sleek, modern product shot of a Coca-Cola glass bottle, set against a vibrant, minimalist background that blends classic red with contemporary design elements. The bottle is illuminated to highlight its contours and the brand logo, with a subtle reflection on a polished surface. The overall feel is crisp, clean, and dynamic, bridging vintage appeal with modern aesthetics.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/images/01K4DPHV74B2MH5K1YFDT9V4TF_0_01K4DPK95C7ZRH5FBKEGK4AKQ1.png",
                "duration": 0,
                "width": 1920,
                "height": 1080,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": "16:9",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            }
        },
        "musics": {
            "01K4DQA2VQHEVDN304Y2K8S027": {
                "id": "01K4DQA2VQHEVDN304Y2K8S027",
                "type": "Music",
                "source": "SYSTEM_GENERATED",
                "prompt": "",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/musics/01K4DQA2VQHEVDN304Y2K8S027_c84f3054833d4899429168dad147698c_1_01K4DQEGK5PHTCNPP1ZT4T5A3S.mp3",
                "duration": 154.68,
                "title": "Refreshing Moments",
                "style": "Uplifting, feel-good pop with a classic commercial jingle feel, bright percussion, and a memorable melody.",
                "mode": "music",
                "vocal_gender": "none",
                "modelKey": "Suno",
                "modelLabel": "Suno"
            }
        },
        "sound_effects": {},
        "speechs": {
            "01K4DQ9WB2SQP0N16DBF4Z611P": {
                "id": "01K4DQ9WB2SQP0N16DBF4Z611P",
                "type": "Speech",
                "source": "SYSTEM_GENERATED",
                "prompt": "Drink Coca-Cola!",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/speechs/01K4DQ9WB2SQP0N16DBF4Z611P_01K4DQBKXDXH6FGG2XPJ6EE31A.wav",
                "duration": 1.8909583333333333,
                "voice_id": "Algenib",
                "voice_id_2": null,
                "modelKey": "gemini/gemini-2.5-pro-preview-tts",
                "modelLabel": "Gemini Speech",
                "tone": "Enthusiastic, confident, and clear, with a friendly and inviting tone."
            }
        },
        "videos": {
            "01K4DPJ3MMDMYGQF5V18ZHR193": {
                "id": "01K4DPJ3MMDMYGQF5V18ZHR193",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The image slowly zooms in, with a subtle wavering effect to simulate an old film projection, bringing the vintage Coca-Cola ad to life on the magazine page.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPJ3MMDMYGQF5V18ZHR193_01K4DPPFDY54AT0B77WVW67QFS.mp4",
                "duration": 8,
                "image_id": "01K4DPHTS9H8ZS33HJ3JQZ72RX",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DPRSGMY6WC842KW3WJ8BAP_copy_01K4DPJ3MMDMYGQF5V18ZHR193": {
                "id": "01K4DPRSGMY6WC842KW3WJ8BAP_copy_01K4DPJ3MMDMYGQF5V18ZHR193",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "A close-up on the glossy pages of a vintage Coca-Cola magazine ad, laid out on a wooden coffee table. The camera focuses on the bold red logo and a beautifully illustrated glass bottle of Coca-Cola on the page. In an Extractive Revelation, the printed image begins to ripple. The bottle illustration lifts off the paper, expanding into a full-sized, hyper-real glass bottle. Condensation beads form on its surface, fizz crackles inside, and the cap pops with a burst of sound. The bottle fully materializes, landing upright on the table with ice-cold refreshment, the Coca-Cola logo gleaming in the cinematic light.\n",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPRSGMY6WC842KW3WJ8BAP_copy_01K4DPJ3MMDMYGQF5V18ZHR193_01K4DPV0812GTD1YX9AG1JZ3Z6.mp4",
                "duration": 8,
                "image_id": "01K4DPHTS9H8ZS33HJ3JQZ72RX",
                "audio_id": "",
                "video_id": "",
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DPJ40S465NA6VWG4PVQNVW": {
                "id": "01K4DPJ40S465NA6VWG4PVQNVW",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The camera subtly pans around the Coca-Cola bottle, highlighting the condensation as it shimmers, with small droplets slowly dripping down the glass, emphasizing its coldness and refreshment.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPJ40S465NA6VWG4PVQNVW_01K4DPP7ATHAYWPPMH7DW74XTD.mp4",
                "duration": 8,
                "image_id": "01K4DPHTW6YX58D8NG5VCFE4H6",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DPJ4AP39NB1ZDM1FDE7N0V": {
                "id": "01K4DPJ4AP39NB1ZDM1FDE7N0V",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The camera smoothly rotates around the modern Coca-Cola bottle, with the background elements subtly morphing or shifting in color, creating a dynamic and visually engaging product showcase.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPJ4AP39NB1ZDM1FDE7N0V_01K4DPPM4K6SDPZAT7KTSS5SDV.mp4",
                "duration": 8,
                "image_id": "01K4DPHV74B2MH5K1YFDT9V4TF",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DPJ47PW3RX2P33PAASBM0F": {
                "id": "01K4DPJ47PW3RX2P33PAASBM0F",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The fizz and bubbles in the Coca-Cola actively rise and pop, with continuous effervescence. Subtle steam or cold mist emanates from the glass, reinforcing the refreshing sensation.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPJ47PW3RX2P33PAASBM0F_01K4DPP9MMXQHP60TAZ8KXX6GN.mp4",
                "duration": 8,
                "image_id": "01K4DPHV2CBMPWG8QT80Z0SQ0P",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DQ5YWZJ7FFGCKWECT9BAF5": {
                "id": "01K4DQ5YWZJ7FFGCKWECT9BAF5",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The clear glass filled with Coca-Cola and ice, already fizzing, intensifies dramatically. The bubbles rapidly grow larger and more numerous, creating an explosive effervescence that spills over the rim of the glass in a cascade of liquid and foam, then instantly recedes back into the glass, leaving it perfectly full and refreshing, as if time has been reversed. Dramatic, hyper-real slow-motion effect.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DQ5YWZJ7FFGCKWECT9BAF5_01K4DQ9BP7GWZ2M1KKCSHZBSS4.mp4",
                "duration": 8,
                "image_id": "01K4DPHV2CBMPWG8QT80Z0SQ0P",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DQ5YMEW37YZHMT3J3PMB5R": {
                "id": "01K4DQ5YMEW37YZHMT3J3PMB5R",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The classic Coca-Cola bottle, initially still, begins to subtly pulsate with an inner glow. Condensation rapidly intensifies, forming rivers of water cascading down its sides, before the bottle dramatically spins and then shatters into a million sparkling droplets, revealing a new, pristine bottle instantly appearing in its place, perfectly chilled. Cinematic, high-speed effect.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DQ5YMEW37YZHMT3J3PMB5R_01K4DQ92X0AN1WEQYTZTEPXQBP.mp4",
                "duration": 8,
                "image_id": "01K4DPHV2CBMPWG8QT80Z0SQ0P",
                "audio_id": "",
                "video_id": "",
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DQ5YRM8ANAZ20ACJDVNFJ0": {
                "id": "01K4DQ5YRM8ANAZ20ACJDVNFJ0",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The sleek, modern Coca-Cola bottle, set against its minimalist background, begins to swirl with digital light particles. The background elements rapidly shift and morph into an abstract, dynamic vortex of red and white, pulling the viewer into a futuristic, energetic dimension, before smoothly resolving back to the original modern shot, highlighting the bottle with renewed intensity. High-tech, fluid transformation.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DQ5YRM8ANAZ20ACJDVNFJ0_01K4DQ90HW1EPMWYCYJSQ8BVH4.mp4",
                "duration": 8,
                "image_id": "01K4DPHV74B2MH5K1YFDT9V4TF",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo"
            },
            "01K4DPJ44SXPFQH0DT7EPZWC5X": {
                "id": "01K4DPJ44SXPFQH0DT7EPZWC5X",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The Coca-Cola liquid continues to pour into the glass, creating more splash and bubbles, while the ice cubes gently shift and settle. The pouring action flows smoothly, enhancing the dynamic feel.",
                "cdn_url": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPJ44SXPFQH0DT7EPZWC5X_01K4DPP8F3RPBR8EC6SY1MBTY5.mp4",
                "duration": 8,
                "image_id": "01K4DPHTZQ13MBJ2XCQEEK8V25",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "16:9",
                "modelKey": "Google-Veo",
                "modelLabel": "Google Veo",
            }
        },
        "timeline_editor": {
            "project_id": "01K4DPDPT0WCN9S4Z9WVB588FM",
            "timeline_duration": 17,
            "background_color": "#000000",
            "tracks": [
                {
                    "index": 0,
                    "label": "Track 1",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 1,
                    "label": "Track 2",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 2,
                    "label": "Track 3",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 3,
                    "label": "Track 4",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 4,
                    "label": "Track 5",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 5,
                    "label": "Track 6",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 6,
                    "label": "Track 7",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 7,
                    "label": "Track 8",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 8,
                    "label": "Track 9",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 9,
                    "label": "Track 10",
                    "locked": false,
                    "visible": true
                }
            ],
            "elements": [
                {
                    "id": "element_1757101655315_619766",
                    "media_id": "01K4DPJ44SXPFQH0DT7EPZWC5X",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPJ44SXPFQH0DT7EPZWC5X_01K4DPP8F3RPBR8EC6SY1MBTY5.mp4",
                    "content": "The Coca-C",
                    "color": "#3b82f6",
                    "track": 2,
                    "start_time": 4.789732069773446,
                    "duration": 3.970422782807418,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": 0,
                    "trim_end": 3.970422782807418,
                    "original_duration": 8
                },
                {
                    "id": "element_1757101908722_135326",
                    "media_id": "01K4DPRSGMY6WC842KW3WJ8BAP_copy_01K4DPJ3MMDMYGQF5V18ZHR193",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DPRSGMY6WC842KW3WJ8BAP_copy_01K4DPJ3MMDMYGQF5V18ZHR193_01K4DPV0812GTD1YX9AG1JZ3Z6.mp4",
                    "content": "A close-up",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 0,
                    "duration": 5.794849257273446,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": 2.2051507427265538,
                    "trim_end": 8,
                    "original_duration": 8
                },
                {
                    "id": "element_1757102378274_411963",
                    "media_id": "01K4DQ9WB2SQP0N16DBF4Z611P",
                    "media_type": "Speech",
                    "src": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/speechs/01K4DQ9WB2SQP0N16DBF4Z611P_01K4DQBKXDXH6FGG2XPJ6EE31A.wav",
                    "content": "Drink Coca",
                    "color": "#f59e0b",
                    "track": 2,
                    "start_time": 9.98607421875,
                    "duration": 1.890958309173584,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757102452519_871031",
                    "media_id": "01K4DQA2VQHEVDN304Y2K8S027",
                    "media_type": "Music",
                    "src": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/musics/01K4DQA2VQHEVDN304Y2K8S027_c84f3054833d4899429168dad147698c_0_01K4DQEGK5JZYJT66XDBW4570F.mp3",
                    "content": "Music Element",
                    "color": "#8b5cf6",
                    "track": 3,
                    "start_time": 0.1519921875,
                    "duration": 16.828021527039773,
                    "local_path": null,
                    "volume": 0.5,
                    "trim_start": 0,
                    "trim_end": 16.828021527039773,
                    "original_duration": 199.9600067138672
                },
                {
                    "id": "element_1757102805963_887317",
                    "media_id": "01K4DQ5YRM8ANAZ20ACJDVNFJ0",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4DPDPT0WCN9S4Z9WVB588FM/videos/01K4DQ5YRM8ANAZ20ACJDVNFJ0_01K4DQ90HW1EPMWYCYJSQ8BVH4.mp4",
                    "content": "The sleek,",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 8.74650147930108,
                    "duration": 5.288162745258338,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": 0.6519851408276249,
                    "trim_end": 5.940147886085963,
                    "original_duration": 8
                }
            ]
        }
    },
    {
        "id": "2",
        "title": "Apartment for Sale in Makadi Heights",
        "concept": "An advertisement showcasing the luxurious features and serene environment of an apartment for sale in Makadi Heights, targeting potential buyers on social media platforms like Instagram and TikTok.",
        "videoSrc": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/exports/output_1757453573.mp4",
        "thumbnailSrc": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HH9HJSV3YF8D7R8P8D.JPG",
        "credits": 864.70,
        "creating_time": "Takes 1 hour to create",
        "type": "video",
        "width": 1080,
        "height": 1920,
        "duration": 30,
        "story": "A potential buyer discovers their dream apartment in Makadi Heights, highlighting the modern amenities, stunning views, and peaceful community.",
        "screen_write": "Scene 1: Drone shot of Makadi Heights. Scene 2: Interior shots of the apartment. Scene 3: Amenities. Scene 4: Call to action.",
        "metadata": {
            "target_audience": "real estate investors, luxury home buyers",
            "platforms": [
                "instagram",
                "tiktok"
            ]
        },
        "characters": {},
        "images": {
            "01K4QZF8HHN0GCNETEWVVQZ0RR": {
                "id": "01K4QZF8HHN0GCNETEWVVQZ0RR",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: bedroom3.jpeg",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HHN0GCNETEWVVQZ0RR.jpeg",
                "duration": 1,
                "width": 654,
                "height": 1200,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QZF8HH9HJSV3YF8D7R8P8D": {
                "id": "01K4QZF8HH9HJSV3YF8D7R8P8D",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: outdoor1.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HH9HJSV3YF8D7R8P8D.JPG",
                "duration": 1,
                "width": 491,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QZF8HHXDFHQFXVWS6PV06D": {
                "id": "01K4QZF8HHXDFHQFXVWS6PV06D",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: window1.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HHXDFHQFXVWS6PV06D.JPG",
                "duration": 1,
                "width": 491,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QZF8HH7DBZP1TK4W8AF8NZ": {
                "id": "01K4QZF8HH7DBZP1TK4W8AF8NZ",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: bedroom2.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HH7DBZP1TK4W8AF8NZ.JPG",
                "duration": 1,
                "width": 491,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QZF8HHPB5CB44REFYME8KM": {
                "id": "01K4QZF8HHPB5CB44REFYME8KM",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: location2.png",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HHPB5CB44REFYME8KM.png",
                "duration": 1,
                "width": 905,
                "height": 1660,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4R0SRSGPM6676GRBXX6C1QQ": {
                "id": "01K4R0SRSGPM6676GRBXX6C1QQ",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "Generate an X-ray view of the buliding to reveal the interior of the building.\nUse an AR experience generator to visualize hidden structures.\nHighlight each point and attach a concise label.\nEnsure labels are informative and easy to understand",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4R0SRSGPM6676GRBXX6C1QQ_01K4R0W4WGRYEYPBCKRAGMFYXQ.png",
                "duration": 5,
                "width": 1080,
                "height": 1920,
                "usage": "STANDALONE",
                "reference_images_ids": [
                    "01K4R0HZBW33XJSW4TX6CNPA5P"
                ],
                "aspect_ratio": "9:16",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4QZF8HH3EHTWRG6RGA4THW3": {
                "id": "01K4QZF8HH3EHTWRG6RGA4THW3",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: indoor2.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HH3EHTWRG6RGA4THW3.JPG",
                "duration": 1,
                "width": 491,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QXNCMH7XE8MKEB7Q580PDZ": {
                "id": "01K4QXNCMH7XE8MKEB7Q580PDZ",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "create a map image of \"Makadi Heights\" in egypt",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QXNCMH7XE8MKEB7Q580PDZ_0_01K4QXRC78ACY5PNDK4GFGJZ9X.png",
                "duration": 5,
                "width": 1080,
                "height": 1920,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": "9:16",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4QZF8HH0QRHSZP87CZ8FP4K": {
                "id": "01K4QZF8HH0QRHSZP87CZ8FP4K",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: indoor1.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HH0QRHSZP87CZ8FP4K.JPG",
                "duration": 1,
                "width": 491,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4R3WBEEYJKRJY2G0RHFJ1GH": {
                "id": "01K4R3WBEEYJKRJY2G0RHFJ1GH",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "A wide-angle shot of the modern building, taken from a slightly lower angle to emphasize its height and architectural details. The building should appear perfectly vertical with no distortion. Ensure the image is cropped to remove any vehicles in the foreground, focusing solely on the building and its immediate surroundings. The sky is clear and blue, and the lighting highlights the building's textures.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4R3WBEEYJKRJY2G0RHFJ1GH_01K4R3XE45TJFRYAY2QWHXE9AS.png",
                "duration": 0,
                "width": 1080,
                "height": 1920,
                "usage": "STANDALONE",
                "reference_images_ids": [
                    "01K4QZF8HH9HJSV3YF8D7R8P8D"
                ],
                "aspect_ratio": "9:16",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4QZPBQ65WZ976HBE6TGZBV0": {
                "id": "01K4QZPBQ65WZ976HBE6TGZBV0",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "High-quality detailed map of Makadi Heights, Egypt, clearly highlighting the precise location of an apartment building (RED PIN). The map should be crisp, make a 3D shape of the building on the map (3D bird view)\n(IMPORTANT NOTE: NEVER CHANGE THE APARTMENT LOCATION, AND MAKE SURE THE 3D BUILDING ON THE RED PIN LOCATION)",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZPBQ65WZ976HBE6TGZBV0_01K4R0P12T0Z0FYJY6DPNV01BZ.png",
                "duration": 0,
                "width": 1080,
                "height": 1920,
                "usage": "STANDALONE",
                "reference_images_ids": [
                    "01K4QZF8HH34Y40NGASXBNTVXS",
                    "01K4R0HZBW33XJSW4TX6CNPA5P"
                ],
                "aspect_ratio": "9:16",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            },
            "01K4QZF8HHVMMW24AR8RR1ZPED": {
                "id": "01K4QZF8HHVMMW24AR8RR1ZPED",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: bedroom1.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HHVMMW24AR8RR1ZPED.JPG",
                "duration": 1,
                "width": 491,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QZF8HHKRS7WPD5M8VMBJ00": {
                "id": "01K4QZF8HHKRS7WPD5M8VMBJ00",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: roof2.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HHKRS7WPD5M8VMBJ00.JPG",
                "duration": 1,
                "width": 490,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QZF8HH34Y40NGASXBNTVXS": {
                "id": "01K4QZF8HH34Y40NGASXBNTVXS",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: location1.png",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HH34Y40NGASXBNTVXS.png",
                "duration": 1,
                "width": 1988,
                "height": 3646,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4QZF8HHCDN0GG67Q1DYB9KH": {
                "id": "01K4QZF8HHCDN0GG67Q1DYB9KH",
                "type": "Image",
                "source": "USER_UPLOADED",
                "prompt": "Uploaded image: roof1.JPG",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4QZF8HHCDN0GG67Q1DYB9KH.JPG",
                "duration": 1,
                "width": 491,
                "height": 900,
                "usage": "STANDALONE",
                "reference_images_ids": [],
                "aspect_ratio": undefined,
                "modelKey": "user_uploaded",
                "modelLabel": "User Uploaded"
            },
            "01K4R0HZBW33XJSW4TX6CNPA5P": {
                "id": "01K4R0HZBW33XJSW4TX6CNPA5P",
                "type": "Image",
                "source": "SYSTEM_GENERATED",
                "prompt": "Make a graphic 3D shape of the building to be used on a map",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/images/01K4R0HZBW33XJSW4TX6CNPA5P_01K4R0ME0RXG8PX0Q2E9QBP4DA.png",
                "duration": 5,
                "width": 1080,
                "height": 1920,
                "usage": "STANDALONE",
                "reference_images_ids": [
                    "01K4QZF8HH9HJSV3YF8D7R8P8D"
                ],
                "aspect_ratio": "9:16",
                "modelKey": "Google-Imagen",
                "modelLabel": "Google Imagen"
            }
        },
        "musics": {
            "01K4R4ZASV6XV2PYNZH153M6VR": {
                "id": "01K4R4ZASV6XV2PYNZH153M6VR",
                "type": "Music",
                "source": "SYSTEM_GENERATED",
                "prompt": "",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/musics/01K4R4ZASV6XV2PYNZH153M6VR_d872b2457e9c0a5f79f66a5dddd707d3_1_01K4R52XHM11WASVW9929Z8714.mp3",
                "duration": 174.2,
                "title": "Makadi Heights Ad Music",
                "style": "Relaxing, gentle, instrumental background music for a luxury apartment advertisement, positive, soft piano melodies, subtle strings, and warm pads.",
                "mode": "music",
                "vocal_gender": "none",
                "modelKey": "Suno",
                "modelLabel": "Suno"
            }
        },
        "sound_effects": {
            "01K4R51B4WC4WDXBR7FTVBD0VS": {
                "id": "01K4R51B4WC4WDXBR7FTVBD0VS",
                "type": "SoundEffect",
                "source": "SYSTEM_GENERATED",
                "prompt": "Long sound effect with gentle beach waves repeating",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/sound_effects/01K4R51B4WC4WDXBR7FTVBD0VS_01K4R5TS3BX5CA3TYZ6CT1SABJ.mp3",
                "duration": 4.048979591836734,
                "modelKey": "elevenlabs/elevenlabs_soundeffect",
                "modelLabel": "ElevenLabs Sound Effect"
            },
            "01K4R4YK7STADT0KVETWGKHNX7": {
                "id": "01K4R4YK7STADT0KVETWGKHNX7",
                "type": "SoundEffect",
                "source": "SYSTEM_GENERATED",
                "prompt": "Birds chirping and flapping wings",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/sound_effects/01K4R4YK7STADT0KVETWGKHNX7_01K4R4YZDG7QF31ME0RTHGCN1Y.mp3",
                "duration": 4.048979591836734,
                "modelKey": "elevenlabs/elevenlabs_soundeffect",
                "modelLabel": "ElevenLabs Sound Effect"
            },
            "01K4R51BANP75Y97V4DPNR17DV": {
                "id": "01K4R51BANP75Y97V4DPNR17DV",
                "type": "SoundEffect",
                "source": "SYSTEM_GENERATED",
                "prompt": "Birds chirping in a natural outdoor environment",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/sound_effects/01K4R51BANP75Y97V4DPNR17DV_01K4R51Q6M6V33MA3F3S07G61V.mp3",
                "duration": 4.048979591836734,
                "modelKey": "elevenlabs/elevenlabs_soundeffect",
                "modelLabel": "ElevenLabs Sound Effect"
            }
        },
        "speechs": {
            "01K4R6FGA2YG66M6BYFF7FJGAY": {
                "id": "01K4R6FGA2YG66M6BYFF7FJGAY",
                "type": "Speech",
                "source": "SYSTEM_GENERATED",
                "prompt": "Speaker 1: Upptäck din drömflykt i Makadi Heights!\nSpeaker 2: Denna fantastiska, fullt möblerade 66 kvm lägenhet, med en privat 35 kvm takterrass, erbjuder panoramautsikt över Röda havet och bergen.\nSpeaker 1: Redo för lyxigt boende eller som en investering.\nSpeaker 2: Tillgänglig för försäljning för 6 miljoner EGP, eller för uthyrning från bara 50 Euro per natt.\nSpeaker 2: Din perfekta Röda havet-semester väntar! Kontakta oss idag!",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/speechs/01K4R6FGA2YG66M6BYFF7FJGAY_01K4R6VG81RW5WDGKHY37MVNWH.wav",
                "duration": 32.81095833333333,
                "voice_id": "Algenib",
                "voice_id_2": "Achernar",
                "tone": "Friendly and engaging, making the apartment feel inviting and accessible, with a warm and conversational delivery, spoken with a Swedish accent.",
                "modelKey": "gemini/gemini-2.5-pro-preview-tts",
                "modelLabel": "Gemini Speech"
            },
            "01K4R3QKRKE0DNYFV0TY8ZXJT7": {
                "id": "01K4R3QKRKE0DNYFV0TY8ZXJT7",
                "type": "Speech",
                "source": "SYSTEM_GENERATED",
                "prompt": "Speaker 1: Discover your dream escape in Makadi Heights!\nSpeaker 2: This stunning, fully furnished 66 sqm apartment, with a private 35 sqm rooftop, offers panoramic Red Sea and mountain views.\nSpeaker 1: Ready for luxurious living or as an investment.\nSpeaker 2: Available for sale at 6 Million EGP, or for rent starting from just 50 Euros a night.\nSpeaker 1: Experience breathtaking views, a spacious balcony, and a rooftop kitchen with a grill.\nSpeaker 2: Your perfect Red Sea getaway awaits! Contact us today!",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/speechs/01K4R3QKRKE0DNYFV0TY8ZXJT7_01K4R5DPSMBR9ZNG7ZSPK9HYBP.wav",
                "duration": 29.250958333333333,
                "voice_id": "Achernar",
                "voice_id_2": "Achird",
                "tone": "Friendly and engaging, making the apartment feel inviting and accessible, with a warm and conversational delivery.",
                "modelKey": "gemini/gemini-2.5-pro-preview-tts",
                "modelLabel": "Gemini Speech"
            },
            "01K4R6FGFZ3DA6SMPXPK85M2WD": {
                "id": "01K4R6FGFZ3DA6SMPXPK85M2WD",
                "type": "Speech",
                "source": "SYSTEM_GENERATED",
                "prompt": "Speaker 1: اكتشف الحلم في مكادي هايتس!\nSpeaker 2: هذه الشقة الرائعة المفروشة بالكامل بمساحة 66 متر مربع، مع تراس خاص على السطح بمساحة 35 متر مربع، توفر إطلالات بانورامية على البحر الأحمر والجبال.\nSpeaker 1: جاهزة للمعيشة الفاخرة أو كاستثمار.\nSpeaker 2: متاحة للبيع بسعر 6 مليون جنيه مصري، أو للإيجار بدءاً من 50 يورو فقط في الليلة.\nSpeaker 1: عطلتك المثالية على البحر الأحمر تنتظرك! اتصل بنا اليوم!",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/speechs/01K4R6FGFZ3DA6SMPXPK85M2WD_01K4R6ST2CNEJAPA5PT8B5XXHX.wav",
                "duration": 30.970958333333332,
                "voice_id": "Achird",
                "voice_id_2": "Achernar",
                "tone": "Friendly and engaging, making the apartment feel inviting and accessible, with a warm and conversational delivery, spoken with an egyptian accent.",
                "modelKey": "gemini/gemini-2.5-pro-preview-tts",
                "modelLabel": "Gemini Speech"
            }
        },
        "videos": {
            "01K4R0YWW51T2C23VXHCSAHS2P": {
                "id": "01K4R0YWW51T2C23VXHCSAHS2P",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The camera slowly zooms in on the 3D building, then slowly pans around it, showcasing its various angles and features.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R0YWW51T2C23VXHCSAHS2P_01K4R15FZRDPZCSCA6AHHVXD01.mp4",
                "duration": 5,
                "image_id": "01K4QZPBQ65WZ976HBE6TGZBV0",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "WanVideo",
                "modelLabel": "WanVideo"
            },
            "01K4R3C6C0H504N29GBD0Z123F": {
                "id": "01K4R3C6C0H504N29GBD0Z123F",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "A smooth, orbiting camera movement slowly circles the distinctive light fixture hanging from the brick-domed ceiling in the bedroom, highlighting its intricate design and the unique architectural feature.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R3C6C0H504N29GBD0Z123F_01K4R3G1R27S5SNQA25K6DQ0E1.mp4",
                "duration": 5.04,
                "image_id": "01K4QZF8HH7DBZP1TK4W8AF8NZ",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "Runway-Video",
                "modelLabel": "Runway Video"
            },
            "01K4R1Y7SWHTTCH2CZ9GBBTRBA": {
                "id": "01K4R1Y7SWHTTCH2CZ9GBBTRBA",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The camera starts inside a room, moves towards a window, smoothly transitions through the window, and reveals the exterior of the building with its surrounding environment, including birds flying in the sky.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R1Y7SWHTTCH2CZ9GBBTRBA_01K4R30DYFZGN9ACKRSGHP8AC0.mp4",
                "duration": 5.04,
                "image_id": "01K4QZF8HHXDFHQFXVWS6PV06D",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "Runway-Video",
                "modelLabel": "Runway Video"
            },
            "01K4R34CRX8RS3F3PQWENMSDQY": {
                "id": "01K4R34CRX8RS3F3PQWENMSDQY",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "A slow, smooth camera movement panning around a modern bedroom, showcasing the bed, window, and decorative elements.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R34CRX8RS3F3PQWENMSDQY_01K4R3F30SSSR0PN1EVJ58F3KP.mp4",
                "duration": 5.04,
                "image_id": "01K4QZF8HHN0GCNETEWVVQZ0RR",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "Runway-Video",
                "modelLabel": "Runway Video"
            },
            "01K4R1G876MBQK9QFPXXHNTM3C": {
                "id": "01K4R1G876MBQK9QFPXXHNTM3C",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The camera starts inside a room with a soft, stable, cinematic push, smoothly gliding towards a window, seamlessly transitioning through the glass, and gracefully revealing the expansive exterior of the building with its surrounding environment, maintaining a professional and continuous motion.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R1G876MBQK9QFPXXHNTM3C_01K4R3Q8GZJDH2YENR0HWY7C6C.mp4",
                "duration": 5.04,
                "image_id": "01K4QZF8HH3EHTWRG6RGA4THW3",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "Runway-Video",
                "modelLabel": "Runway Video"
            },
            "01K4R42GZAAHZE6ZZX4NMP8792": {
                "id": "01K4R42GZAAHZE6ZZX4NMP8792",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "A slow pan across the building, with birds flying in the clear blue sky.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R42GZAAHZE6ZZX4NMP8792_01K4R5BDKYZ02WD5PF9M3HA90J.mp4",
                "duration": 5.04,
                "image_id": "01K4R3WBEEYJKRJY2G0RHFJ1GH",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "Runway-Video",
                "modelLabel": "Runway Video"
            },
            "01K4R31N7V0T98S4K34CAQ9WWK": {
                "id": "01K4R31N7V0T98S4K34CAQ9WWK",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "A slow, cinematic camera movement to the sky, with birds gracefully flying in the sky above.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R31N7V0T98S4K34CAQ9WWK_01K4R3E547DTCSMBF8V8ZJ7JT4.mp4",
                "duration": 5,
                "image_id": "01K4QZF8HHKRS7WPD5M8VMBJ00",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "WanVideo",
                "modelLabel": "WanVideo"
            },
            "01K4R19VF5KG520YHQ32F6BF35": {
                "id": "01K4R19VF5KG520YHQ32F6BF35",
                "type": "Video",
                "source": "SYSTEM_GENERATED",
                "prompt": "The camera starts with a close-up view of a detail in the room, then slowly pulls back and pans to reveal the entire interior of the room, showcasing the kitchen area, door, and decorative elements. The camera then smoothly moves throughout the room, highlighting various features and creating a sense of a walk-through.",
                "cdn_url": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R19VF5KG520YHQ32F6BF35_01K4R1W3VQ5MH3YC1GBMVQCF34.mp4",
                "duration": 5,
                "image_id": "01K4QZF8HH0QRHSZP87CZ8FP4K",
                "audio_id": null,
                "video_id": null,
                "aspect_ratio": "9:16",
                "modelKey": "WanVideo",
                "modelLabel": "WanVideo"
            }
        },
        "timeline_editor": {
            "project_id": "01K4QX3XZ8YE62FXPT80MBFQ62",
            "timeline_duration": 33,
            "background_color": "#000000",
            "tracks": [
                {
                    "index": 0,
                    "label": "Track 1",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 1,
                    "label": "Track 2",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 2,
                    "label": "Track 3",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 3,
                    "label": "Track 4",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 4,
                    "label": "Track 5",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 5,
                    "label": "Track 6",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 6,
                    "label": "Track 7",
                    "locked": false,
                    "visible": false
                },
                {
                    "index": 7,
                    "label": "Track 8",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 8,
                    "label": "Track 9",
                    "locked": false,
                    "visible": true
                },
                {
                    "index": 9,
                    "label": "Track 10",
                    "locked": false,
                    "visible": true
                }
            ],
            "elements": [
                {
                    "id": "element_1757450620736_578390",
                    "media_id": "01K4R0YWW51T2C23VXHCSAHS2P",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R0YWW51T2C23VXHCSAHS2P_01K4R15FZRDPZCSCA6AHHVXD01.mp4",
                    "content": "The camera",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 0,
                    "duration": 4,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757450623838_733820",
                    "media_id": "01K4R19VF5KG520YHQ32F6BF35",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R19VF5KG520YHQ32F6BF35_01K4R1W3VQ5MH3YC1GBMVQCF34.mp4",
                    "content": "The camera",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 4,
                    "duration": 4,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757450633405_781584",
                    "media_id": "01K4R1Y7SWHTTCH2CZ9GBBTRBA",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R1Y7SWHTTCH2CZ9GBBTRBA_01K4R30DYFZGN9ACKRSGHP8AC0.mp4",
                    "content": "The camera",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 16,
                    "duration": 4,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757450640775_430270",
                    "media_id": "01K4R31N7V0T98S4K34CAQ9WWK",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R31N7V0T98S4K34CAQ9WWK_01K4R3E547DTCSMBF8V8ZJ7JT4.mp4",
                    "content": "A slow, ci",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 8,
                    "duration": 4,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757450644084_728821",
                    "media_id": "01K4R3C6C0H504N29GBD0Z123F",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R3C6C0H504N29GBD0Z123F_01K4R3G1R27S5SNQA25K6DQ0E1.mp4",
                    "content": "A smooth, ",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 24,
                    "duration": 4,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757450646102_922489",
                    "media_id": "01K4R34CRX8RS3F3PQWENMSDQY",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R34CRX8RS3F3PQWENMSDQY_01K4R3F30SSSR0PN1EVJ58F3KP.mp4",
                    "content": "A slow, sm",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 20,
                    "duration": 4,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757450869590_405836",
                    "media_id": "01K4R1G876MBQK9QFPXXHNTM3C",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R1G876MBQK9QFPXXHNTM3C_01K4R3Q8GZJDH2YENR0HWY7C6C.mp4",
                    "content": "The camera",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 12,
                    "duration": 4,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757451391191_737259",
                    "media_id": "01K4R42GZAAHZE6ZZX4NMP8792",
                    "media_type": "Video",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/videos/01K4R42GZAAHZE6ZZX4NMP8792_01K4R46E8HTYJXJY2ZCHBQAGBV.mp4",
                    "content": "A slow pan",
                    "color": "#3b82f6",
                    "track": 1,
                    "start_time": 28,
                    "duration": 5.039999961853027,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757452249353_210681",
                    "media_id": "01K4R51BANP75Y97V4DPNR17DV",
                    "media_type": "SoundEffect",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/sound_effects/01K4R51BANP75Y97V4DPNR17DV_01K4R51Q6M6V33MA3F3S07G61V.mp3",
                    "content": "Birds chir",
                    "color": "#ef4444",
                    "track": 3,
                    "start_time": 7.864980468750001,
                    "duration": 4.048979759216309,
                    "local_path": null,
                    "volume": 0.15,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757452656398_285236",
                    "media_id": "01K4R3QKRKE0DNYFV0TY8ZXJT7",
                    "media_type": "Speech",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/speechs/01K4R3QKRKE0DNYFV0TY8ZXJT7_01K4R5DPSMBR9ZNG7ZSPK9HYBP.wav",
                    "content": "Speaker 1:",
                    "color": "#f59e0b",
                    "track": 2,
                    "start_time": 1.49361328125,
                    "duration": 29.250957489013672,
                    "local_path": null,
                    "volume": 1,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757453067706_356879",
                    "media_id": "01K4R51B4WC4WDXBR7FTVBD0VS",
                    "media_type": "SoundEffect",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/sound_effects/01K4R51B4WC4WDXBR7FTVBD0VS_01K4R5SDNQPC2HNFKW5BK8XTSH.mp3",
                    "content": "Gentle bea",
                    "color": "#ef4444",
                    "track": 3,
                    "start_time": 14.11822265625,
                    "duration": 4.048979759216309,
                    "local_path": null,
                    "volume": 0.15,
                    "trim_start": null,
                    "trim_end": null,
                    "original_duration": null
                },
                {
                    "id": "element_1757453219217_295655",
                    "media_id": "01K4R4ZASV6XV2PYNZH153M6VR",
                    "media_type": "Music",
                    "src": "https://cdn.aibrush.co/01K4QX3XZ8YE62FXPT80MBFQ62/musics/01K4R4ZASV6XV2PYNZH153M6VR_d872b2457e9c0a5f79f66a5dddd707d3_0_01K4R52XHMEEXGCH1A72V68BFN.mp3",
                    "content": "Music Element",
                    "color": "#8b5cf6",
                    "track": 4,
                    "start_time": 0,
                    "duration": 33.09080534126618,
                    "local_path": null,
                    "volume": 0.35,
                    "trim_start": 10.665034308474338,
                    "trim_end": 43.75583964974052,
                    "original_duration": 170
                }
            ]
        }
    }
]